<template>
  <div class="payment-view">
    <div class="va-row add-row">
      <div class="col-md-5">
        <div class="form-group">
          <div class="input-group">
            <vuestic-simple-select
              :label="$t('trip.expenses.documentDescription')"
              v-model="documentDescription"
              name="documentDescription"
              ref="documentDescription"
              option-key="name"
              :options="documentDescriptions"
            ></vuestic-simple-select>
          </div>
        </div>
      </div>
    </div>
    <div class="va-row add-row">
      <div class="form-group">
        <div class="col-md-5">
          <vuestic-simple-select
            :label="$t('trip.expenses.documentType')"
            v-model="documentType"
            name="documentType"
            ref="documentType"
            option-key="name"
            :options="documentTypes"
          ></vuestic-simple-select>
        </div>
        <div class="col-md-3">
          <div class="form-group with-icon-right">
            <div class="input-group">
              <input v-model="documentNumber" id="documentNumber" autocomplete="off"/>
              <label
                class="control-label placeholder-label"
                for="documentNumber"
                role="button"
              >{{$t('trip.expenses.documentNumber')}}</label>
              <i class="bar"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <div class="input-group">
              <vuestic-date-picker
                id="payment-date"
                :config="paymentDateConfig"
                v-model="date"
              />
              <label class="control-label" for="payment-date">{{ $t('trip.expenses.documentIssueDate') }}</label>
              <i class="bar"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="va-row add-row">
      <div class="form-group">
        <div class="col-md-3">
          <div class="form-group with-icon-right">
            <div class="input-group">
              <input v-model="measure" id="documentMeasure" autocomplete="off"/>
              <label
                class="control-label placeholder-label"
                for="documentMeasure"
                role="button"
              >{{$t('trip.expenses.documentMeasure')}}</label>
              <i class="bar"></i>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group with-icon-right">
            <div class="input-group">
              <input v-model="quantity" id="documentQantity" autocomplete="off"/>
              <label
                class="control-label placeholder-label"
                for="documentQantity"
                role="button"
              >{{$t('trip.expenses.documentQantity')}}</label>
              <i class="bar"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group with-icon-right">
            <div class="input-group">
              <input v-model="price" id="documentPrice" autocomplete="off"/>
              <label
                class="control-label placeholder-label"
                for="documentPrice"
                role="button"
              >{{$t('trip.expenses.documentPrice')}}</label>
              <i class="bar"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group with-icon-right">
            <div class="input-group">
              <textarea v-model="documentTotal" id="documentTotal"  autocomplete="off" style="display:none"/>
              <label
                class="control-label placeholder-label"
                for="documentTotal"
                role="button"
              >{{$t('trip.expenses.documentTotal')}}</label>
              <div style="margin-top: 8px;" class="no-select">
                {{  documentTotal }}
              </div>
              <i class="bar"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="va-row add-row">
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-group">
            <textarea
              id="notes-textarea"
              class="notes-wrapper"
              style="margin-top:10px"
              v-model="priceNotes"
              type="text"/>
            <label class="control-label placeholder-label">{{ $t(`trip.expenses.documentNote`) }}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="va-row" v-if="!this.isEditing">
      <div class="flex text-center" style="margin: auto">
        <button type="button" class="btn btn-micro btn-primary"
        @click="createExpense"
        :disabled="isValid">
          <span aria-hidden="true" class="fa fa-plus" style="font-size: 16px;"></span>
          {{ $t(`payment.${isEditing ? "edit" : "add"}`) }}
        </button>

        <button type="button" class="btn btn-micro btn-warning md3 offset--md1"
        style="margin-left: 16px;"
        @click="clearData">
          <span aria-hidden="true" class="fa fa-warning" style="font-size: 16px;"></span>
          {{ $t(`trip.expenses.clearData`) }}
        </button>
      </div>
    </div>
    <div v-if="isLoading" class="spinner center">
      <div class="spinner-box">
        <div data-v-2767e9c3 class="orbit-spinner" style="height: 80px; width: 80px;">
          <div
            data-v-2767e9c3
            class="orbit one"
            style="border-color: rgb(74, 227, 135); animation-duration: 1500ms;"
          ></div>
          <div
            data-v-2767e9c3
            class="orbit two"
            style="border-color: rgb(74, 227, 135); animation-duration: 1500ms;"
          ></div>
          <div
            data-v-2767e9c3
            class="orbit three"
            style="border-color: rgb(74, 227, 135); animation-duration: 1500ms;"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { paymentApi } from '../../../services/api/paymentApi"';
import _ from 'lodash';
import moment from 'moment';
import { dateLocaleBG, serverDateLocale, dateLocale, formatCurrency } from '../../../utils';

export default {
  name: 'ExpenseEditor',
  props: {
    tripId: Number,
    expenseData: {
      type: Object
    }
  },
  async created() {
    // TOOD: start loading if needed
    // this.isLoading = true;
    console.log('Expense:', this.expenseData);
    this.debouncedUpdate = _.debounce(this.expensePropertyChanged, 500);
  },

  computed: {
    /**
     * @returns {number} total price
     */
    documentTotal() {
      return this.quantity * this.price;
    },
    /**
     * @returns {boolean} if we are in a position to save or create a record
     */
    isValid() {
      return !(this.date !== ''
      && this.documentType !== ''
      && this.documentDescription !== ''
      && this.documentNumber !== '');
    },
    /**
     * @returns {boolean} if the compoent should fire a change event
     */
    shouldUpdate() {
      // return true;
      console.log(`shouldUpdate = ${this.isValid && this.isEditing}`);
      return this.isEditing
    }
  },
  data() {
    return {
      date: moment().format(dateLocale),
      isLoading: false,
      isEditing: false,
      documentTypes: [
        { id: 'invoice', name: this.$t('trip.expenses.documentTypes.invoice') },
        { id: 'expense', name: this.$t('trip.expenses.documentTypes.expense') },
        { id: 'receipt', name: this.$t('trip.expenses.documentTypes.receipt') },
        { id: 'protocol', name: this.$t('trip.expenses.documentTypes.protocol') },
      ],
      documentType: { id: 'invoice', name: this.$t('trip.expenses.documentTypes.invoice') },
      documentDescriptions: [
        { id: 'exp-travel', name: this.$t('trip.expenses.documentDescriptions.exp-travel') },
        { id: 'exp-drivers', name: this.$t('trip.expenses.documentDescriptions.exp-drivers') },
        { id: 'exp-hotel', name: this.$t('trip.expenses.documentDescriptions.exp-hotel') },
        { id: 'exp-tickets', name: this.$t('trip.expenses.documentDescriptions.exp-tickets') },
        { id: 'exp-plain', name: this.$t('trip.expenses.documentDescriptions.exp-plain') },
        { id: 'exp-insurance', name: this.$t('trip.expenses.documentDescriptions.exp-insurance') },
        { id: 'exp-package', name: this.$t('trip.expenses.documentDescriptions.exp-package') },
        { id: 'exp-unknown', name: this.$t('trip.expenses.documentDescriptions.exp-unknown') },
      ],
      documentDescription: { id: 'exp-unknown', name: this.$t('trip.expenses.documentDescriptions.exp-unknown') },
      paymentDateConfig: {
        dateFormat: 'd-m-Y',
        locale: { firstDayOfWeek: 1 }
      },
      documentNumber: '000000000',
      measure: '',
      quantity: 1,
      price: 0,
      priceNotes: ''
    };
  },
  watch: {
    expenseData(newExpense) {
      if(newExpense != null) {
        this.isEditing = false;
        console.log(`Expense = ${newExpense}`);
        this.documentNumber = newExpense.documentNumber;
        console.log(`Expense = ${newExpense}`);
        this.measure = newExpense.measure;
        this.quantity = newExpense.quantity;
        this.price = newExpense.price;
        this.priceNotes = newExpense.priceNotes;
        
        this.documentType = this.documentTypes.find((item) => item.id === newExpense.documentType);
        if (this.documentType === undefined) {
          this.documentType = { id: 'invoice', name: this.$t('trip.expenses.documentTypes.invoice') };
        }
        this.documentDescription = this.documentDescriptions.find((item) => item.id === newExpense.description);
        if (this.documentDescription === undefined) {
          this.documentDescription = { id: 'exp-unknown', name: this.$t('trip.expenses.documentDescriptions.exp-unknown') };
        }
        this.date = moment(newExpense.issueDate).format(dateLocale);
        this.$nextTick(() => {
          setTimeout(() => {
            this.isEditing = true;
          }, 1000);
          
        });
        
      } else {
        this.isEditing = false;
        this.date = moment().format(dateLocale);
        this.documentDescription = { id: 'exp-unknown', name: this.$t('trip.expenses.documentDescriptions.exp-unknown') };
        this.documentType = { id: 'invoice', name: this.$t('trip.expenses.documentTypes.invoice') };
        this.documentNumber = '000000000';
        this.measure = '';
        this.quantity = 1;
        this.price = 0;
        this.priceNotes = '';
      }
    },
    documentDescription: {
      handler(newValue, oldValue) {
        if (this.isEditing) {
          if (newValue !== '') {
            let change = {
              field: 'description',
              value: newValue.id
            };
            this.debouncedUpdate(change);
            // this.$emit('update-expense', change);
          }
        }
      }
    },
    documentType: {
      handler(newValue, oldValue) {
        if (this.isEditing) {
          if (newValue !== '') {
            let change = {
              field: 'documentType',
              value: newValue.id
            };
            this.debouncedUpdate(change);
            // this.$emit('update-expense', change);
          }
        }
      }
    },
    measure: {
      handler(newValue, oldValue) {
        if (this.isEditing) {
          if (newValue !== oldValue) {
            let change = {
              field: 'measure',
              value: newValue
            };
            this.debouncedUpdate(change);
            // this.$emit('update-expense', change);
          }
        }
      }
    },
    price: {
      handler(newValue, oldValue) {
        if (this.isEditing) {
          if (newValue !== oldValue) {
            let change = {
              field: 'price',
              value: parseFloat(newValue)
            };
            this.debouncedUpdate(change);
            // this.$emit('update-expense', change);
          }
        }
      }
    },
    quantity: {
      handler(newValue, oldValue) {
        if (this.isEditing) {
          if (parseFloat(newValue) !== parseFloat(oldValue)) {
            let change = {
              field: 'quantity',
              value: parseFloat(newValue)
            };
            this.debouncedUpdate(change);
            // this.$emit('update-expense', change);
          }
        }
      }
    },
    priceNotes: {
      handler(newValue, oldValue) {
        if (this.isEditing) {
          if (newValue !== oldValue) {
            let change = {
              field: 'priceNotes',
              value: newValue
            };
            this.debouncedUpdate(change);
            // this.$emit('update-expense', change);
          }
        }
      }
    },
    documentNumber: {
      handler(newValue, oldValue) {
        if (this.isEditing) {
          if (newValue !== oldValue) {
            let change = {
              field: 'documentNumber',
              value: newValue
            };
            this.debouncedUpdate(change);
            // this.$emit('update-expense', change);
          }
        }
      }
    },
    date: {
      handler(newValue, oldValue) {
        if (this.isEditing) {
          if (newValue !== oldValue) {
            let date = moment(newValue, dateLocaleBG).format(serverDateLocale);
            let change = {
              field: 'issueDate',
              value: date
            };
            this.debouncedUpdate(change);
            // this.$emit('update-expense', change);
          }
        }
      }
    },
  },
  methods: {
    createExpense() {
      let date = moment(this.date, dateLocaleBG).format(serverDateLocale);
      let createdData = {
        documentType: this.documentType.id,
        documentNumber: this.documentNumber,
        issueDate: date,
        description: this.documentDescription.id,
        measure: this.measure,
        quantity: parseFloat(this.quantity),
        price: parseFloat(this.price),
        priceNotes: this.priceNotes
      };
      this.$emit('add-expense', createdData);
    },
    clearData() {
      this.date = moment().format(dateLocale);
      this.documentDescription = { id: 'exp-unknown', name: this.$t('trip.expenses.documentDescriptions.exp-unknown') };
      this.documentType = { id: 'invoice', name: this.$t('trip.expenses.documentTypes.invoice') };
      this.documentNumber = '000000000';
      this.measure = '';
      this.quantity = 1;
      this.price = 0;
      this.priceNotes = '';
    },
    // updateExpense() {
    //   let updatedExpense = {
    //     documentNumber: this.documentNumber,
    //     measure: this.measure,
    //     quantity: parseFloat(this.quantity),
    //     price: parseFloat(this.price),
    //     priceNotes: this.priceNotes
    //   };
    //   this.$emit('update-expense', updatedExpense);
    // },
    expensePropertyChanged(changeData) {
      // console.log(`Change data = ${JSON.stringify(changeData)}`);
      this.$emit('update-expense', changeData);
    },
    toCurrency(number) {
      // if (number < 0) return formatCurrency(0, this.$i18n.locale());
      return formatCurrency(number, this.$i18n.locale());
    },
  }
};
</script>

<style lang="scss">
.payment-view {
  .spinner {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9999;
    background-color: #625c5cd6;
    top: 0;
    left: 0;
  }

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modals-list {
    .btn {
      margin-right: 20px;
      margin-bottom: 25px;
    }
  }

  .icon-grid-container:hover {
    cursor: pointer;
  }

  .add-row {
    margin: 0 auto;
  }

  .total-border {
    border-top: 1px solid #555555;
  }

  .closer {
    margin-top: -2%;
  }

  .payment-info-row:hover .edit-icon::before {
    content: "\270F";
  }

  .payment-info-row:hover .invoice-icon::before {
    content: "\02758$\02758";
  }

  .ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .payment-table td {
    padding-left: 0.4rem !important;
  }

  .notes-wrapper {
    border: 1px solid #b4c1b8;
    border-radius: 10px;
    padding: 14px;
  }

  .no-select {
    user-select: none;
  }
}
</style>
